import { useState, useEffect, useRef } from "react";
import * as axios from "axios";
import { ArticleExtraData } from "../../../../../articlePage/stateInterfaces";
import { ToggleSwitch } from "../../../../commonComponents/inline/toggleSwitch/toggleSwitch";
import { getTranslation } from "../../autoTickerRowWidget/autoTickerRowTranslations";
import { FlashPageSpecialItem } from "./flashPageSpecialItem";
import { addAxiosDateTransformerSettings } from "../../../../../utils/network/axiosDateTransformer";

interface accordionProps {
    isLTR: boolean
    languageCode: string
    items: ArticleExtraData[]
    roofOngoingEvent: boolean
    tabBackgroundColor: string
    componentaId: string
}

export const FlashPageSpecialComponent = (props: accordionProps) => {

    const { items: initialItems, languageCode, isLTR, roofOngoingEvent, tabBackgroundColor, componentaId } = props;
    const [items, setItems] = useState<ArticleExtraData[]>(initialItems);
    const [openedItemIndex, setOpenedItemIndex] = useState<string | null>(getSharedItem() || null);
    const [typeOfView, setTypeOfView] = useState<string>("regular");
    const [openedItems, setOpenedItems] = useState<string[]>([]);
    const intervalRef: any = useRef(null);

    const lang = languageCode ? languageCode.slice(0, 2) : "he";

    useEffect(() => {
        setItems(initialItems);
    }, [initialItems]);

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            fetchTickerArticles();
        }, 60000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const fetchTickerArticles = () => {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());

        axiosInstance.get(`/iphone/json/api/auto_ticker/${componentaId}`)
            .then((res: any) => {
                setItems(res.data.data);
            })
            .catch(err => console.error("error getting ticker data:", err));
    };

    const openItem = (id: string) => {
        setOpenedItems([...openedItems, id])
    }

    const closeItem = (id: string) => {
        setOpenedItems(openedItems.filter(i => i !== id))
    }

    const itemToggle = (i: number) => {
        if (typeOfView === "expanded") {
            const idx = openedItems.findIndex(id => id === items[i].articleId);
            const articleId = items[i].articleId;
            (idx !== -1) ? closeItem(articleId) : openItem(articleId)
        } else {
            if (items[i].articleId === openedItemIndex) {
                setOpenedItemIndex(null)
            } else {
                setOpenedItemIndex(items[i].articleId)
            }
        }
    }

    const onSwitchChange = () => {
        if (typeOfView === "regular") {
            setTypeOfView("expanded")
            const allIds = items.map(item => item.articleId)
            const missing = allIds.filter(id => !openedItems.includes(id))
            setOpenedItems([...openedItems, ...missing])
        } else if (typeOfView === "expanded") {
            setTypeOfView("regular")
            setOpenedItems([])
        }
    }

    return (
        <div className="flash-page-special-component">
            <div className="flash-page-special-tab" style={{ backgroundColor: tabBackgroundColor }}>
                <div className="tab-title">
                    <div className="tab-icon"></div>

                    <div className="tab-text">{getTranslation(lang, "News Flash")}</div>
                </div>

                <div className="display-mode-toggle">
                    <div className="toggle-title">{getTranslation(lang, "ExtendedView")}</div>

                    <ToggleSwitch checked={typeOfView === "expanded"} onSwitchPressed={onSwitchChange} />
                </div>
            </div>

            <div className="slotList">
                {items.map((item, i) => {
                    const previousRoof = i > 0 ? (items[i - 1] as ArticleExtraData).roof : null;
                    const nextRoof = i < items.length - 1 ? (items[i + 1] as ArticleExtraData).roof : null;

                    return (
                        <FlashPageSpecialItem
                            index={i}
                            isLTR={isLTR}
                            article={item}
                            nextRoof={nextRoof}
                            key={item.articleId}
                            previousRoof={previousRoof}
                            languageCode={languageCode}
                            roofOngoingEvent={roofOngoingEvent}
                            accordionOpenState={typeOfView === "expanded" || item.articleId === openedItemIndex || openedItems.includes(item.articleId)}
                            onToggle={() => itemToggle(i)}
                        />
                    )
                })}
            </div>
        </div>
    )
}

FlashPageSpecialComponent.siteScriptName = "FlashPageSpecialComponent"

const getSharedItem = (): string => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    const urlSliceIndex = url.indexOf("#")
    if (urlSliceIndex !== -1) {
        return url.slice(urlSliceIndex + 1)
    }
    return ""
}